import { Row } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { IMAGES } from '~/assets/assetsPath';
import styles from './PolicyPost.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { useParams } from 'react-router';
import notificationAPI from '~/api/NotificationAPI';
import { Spin } from 'antd';

const cx = classNames.bind(styles);

const PolicyPost = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [content, setContent] = useState([]);
    const { slug } = useParams();

    const handleGetContentPolicy = async () => {
        setIsLoading(true);
        try {
            const params = {
                fields: `["$all", {"category_post" : ["$all"]}]`,
                filter: `{"slug":"${slug}"}`,
                order: `[["created_at", "desc"]]`,
                limit: 10,
                page: 1,
            };
            const res = await notificationAPI.getPostAPI(params);
            setContent(res?.results.objects?.rows);
        } catch (err) {
            console.log(err);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        handleGetContentPolicy();
        // eslint-disable-next-line
    }, [slug]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangChinhSachBaoMat');
        // eslint-disable-next-line
    }, [slug]);

    return (
        <div className="">
            <div className={cx('banner')}>
                <img src={IMAGES.ImageBannerServiceProduct} alt="Banner Spa" />
            </div>
            {isLoading ? (
                <Row justify="center" align="middle" style={{ height: '500px' }}>
                    <Spin />
                </Row>
            ) : (
                <>
                    {content?.length ? (
                        <div className={cx('service_home_spa')}>
                            <Row className={cx('title')}>{content[0]?.title}</Row>
                            <Row>
                                <div dangerouslySetInnerHTML={{ __html: content[0]?.description_cms }}></div>
                            </Row>
                        </div>
                    ) : (
                        <div className={cx('no_exist')}>
                            <span>Policy does not exist!</span>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default PolicyPost;
